import { ButtonLink } from '../components/Button';
import { Blob } from '../components/Decorations';
import { Reveal } from '../components/Reveal';
import { site } from '../content/site';

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-mint-200 via-mint-100 to-cream">
      {/* Ambient shapes. Decorative only, and they stop moving under reduced-motion. */}
      <Blob
        className="pointer-events-none absolute -top-32 -left-28 h-[26rem] w-[26rem] text-mint-300/40"
        drift
      />
      <Blob
        className="pointer-events-none absolute -right-24 -bottom-40 h-[22rem] w-[22rem] text-blush-200/40"
        drift
      />

      {/* Two columns only from lg — at 768 the text column gets too narrow and the CTAs wrap. */}
      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-6 pt-12 pb-24 sm:px-8 lg:grid-cols-[1.1fr_1fr] lg:gap-8 lg:pt-20 lg:pb-32">
        <div className="order-2 text-center lg:order-1 lg:text-left">
          <Reveal>
            <p className="font-display text-sm font-semibold tracking-[0.18em] text-mint-800 uppercase">
              {site.role} · {site.location}
            </p>
          </Reveal>

          <Reveal delay={90}>
            <h1 className="mt-5 text-4xl leading-[1.08] sm:text-5xl lg:text-6xl">
              Hi, I&apos;m {site.firstName}.
              {/* blush-500 on the mint wash is ~2.6:1 and fails AA even for large text. */}
              <span className="mt-2 block text-blush-600">
                Your child is in warm hands.
              </span>
            </h1>
          </Reveal>

          <Reveal delay={180}>
            <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted lg:mx-0">
              Over a decade of caring for infants through five-year-olds — as a nanny, a preschool
              teacher and a lead teacher. CPR, First Aid and Fire Safety certified.
            </p>
          </Reveal>

          <Reveal delay={270}>
            <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row sm:justify-center lg:justify-start">
              <ButtonLink to="/contact" variant="blush">
                💬 Let&apos;s start a dialog
              </ButtonLink>
              <ButtonLink to="/resume" variant="quiet">
                🎓 See my experience
              </ButtonLink>
            </div>
          </Reveal>
        </div>

        <Reveal delay={120} className="order-1 lg:order-2">
          <div className="relative mx-auto w-full max-w-sm">
            <div className="absolute inset-x-6 top-6 bottom-0 rounded-full bg-white/50 blur-2xl" />
            <Blob className="absolute inset-0 h-full w-full text-mint-400/70" />
            <div className="relative flex justify-end pt-6">
              {/*
                The source photo is 290x355. It is capped here so it stays crisp; when a
                higher-resolution cutout replaces public/images/courtney.png, raise the clamp.
              */}
              <img
                src="/images/courtney.png"
                alt="Courtney, smiling, with sunglasses pushed up on her head"
                width={290}
                height={355}
                className="portrait-fade w-[clamp(210px,58vw,300px)] drop-shadow-[0_25px_35px_rgba(47,62,58,0.22)]"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
